import { persistAffiliateKey } from '../utils/localStorage'

export default async (to, from, next) => {
  if (to.query.affiliateKey && to.query.affiliateKey !== '') {
    persistAffiliateKey(to.query.affiliateKey)
  }

  next()
}
